import { useCallback, useState } from 'react';
import { RouteName } from '@mews-commander/enums';
import { ResourceBlock, useInvalidateRepositoryQuery } from '@mews-commander/data-access';
import { DialogBackendPage, useDialogBackendPage } from '../../../../app/components/DialogBackendPage';
import { ResourceBlocksTable, ResourceBlocksTableProps } from './table';

type ResourceBlocksContentProps = Pick<ResourceBlocksTableProps, 'filterValues'>;

export const ResourceBlocksContent = ({ filterValues }: ResourceBlocksContentProps) => {
    const [selectedResourceBlock, setSelectedResourceBlock] = useState<ResourceBlock | undefined>(undefined);
    const invalidateQuery = useInvalidateRepositoryQuery();

    const handleSubmit = useCallback(() => {
        setSelectedResourceBlock(undefined);
        void invalidateQuery('resourceBlocks', 'getAll');
    }, [invalidateQuery]);

    const [dialogProps, toggleDialog] = useDialogBackendPage({
        title: selectedResourceBlock?.name,
        routeName: RouteName.ResourceBlockDetail,
        params: { id: selectedResourceBlock?.id },
        onSubmit: handleSubmit,
    });

    const handleResourceBlockClick = useCallback(
        (data: ResourceBlock) => {
            setSelectedResourceBlock(data);
            toggleDialog();
        },
        [toggleDialog]
    );

    return (
        <>
            <ResourceBlocksTable filterValues={filterValues} handleResourceBlockClick={handleResourceBlockClick} />
            {selectedResourceBlock ? <DialogBackendPage {...dialogProps} /> : null}
        </>
    );
};
